import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class HMap extends PureComponent {
    static propTypes = {
        data: PropTypes.array,
        nanhai: PropTypes.string,
    };

    map = null;

    async componentDidMount() {
        // 引入 ECharts 主模块
        const echarts = await import('echarts/lib/echarts');

        // 引入中国地图
        await import('echarts/map/js/china');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');
        await import('echarts/lib/component/legend');
        await import('echarts/lib/component/legendScroll');

        const { data } = this.props;

        const list = data.map(item => {
            let num = 0;

            const quezhen = item.quezhen || 0;
            const zhiyu = item.zhiyu || 0;
            const siwang = item.siwang || 0;

            if (item.quezhen_xianyou) {
                num = item.quezhen_xianyou;
            } else {
                num = quezhen - zhiyu - siwang;
            }

            return {
                name: item.name1 === '港澳台' ? item.name2 : item.name1,
                itemStyle: {
                    normal: {
                        areaColor: this.getColor(num),
                    },
                },
                label: {
                    color: num < 1000 ? '#000' : '#fff',
                },
            };
        });

        this.map = echarts.init(document.getElementById('hmap'));

        const chinaMap = require('../../map/china');

        echarts.registerMap('china', chinaMap);

        const option = {
            tooltip: {
                show: false,
                trigger: 'item',
                formatter: '{b}',
            },
            series: [
                {
                    name: '中国',
                    type: 'map',
                    mapType: 'china',
                    silent: true,
                    left: 0,
                    right: 0,
                    top: 0,
                    itemStyle: {
                        normal: {
                            borderColor: '#E2B2B2', // 边框颜色
                            borderWidth: 0.5, // 边框线宽
                        },
                    },
                    label: {
                        show: true,
                        textStyle: {
                            // 标签的文本样式
                            fontSize: 6,
                            fontFamily: 'PingFang Light',
                            color: '#1F1F1F',
                        },
                    },
                    data: list,
                },
            ],
        };

        this.map.setOption(option);
    }

    getColor = num => {
        let color = '#F2DADB';

        if (num > 9999) {
            color = '#600A0A';
        } else if (num > 999) {
            color = '#9E0707';
        } else if (num > 99) {
            color = '#BF5A53';
        } else if (num > 9) {
            color = '#CE8A86';
        } else if (num === 0) {
            color = '#ffffff';
        }

        return color;
    };

    render() {
        const { nanhai } = this.props;

        return (
            <div className={styles.box}>
                <div id="hmap" className={styles.map} />
                <img
                    crossOrigin="Anonymous"
                    className={styles.tip}
                    src="https://x0.ifengimg.com/ucms/2020_07/7CFE7251B08A6E04583E41AB04DE8D914BABBAC3_w246_h210.png"
                />
                <img crossOrigin="Anonymous" className={styles.nanhai} src={nanhai} />
            </div>
        );
    }
}

export default errorBoundary(HMap);
